var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgE9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ri:arrow-up-down-line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.95 7.95L10.536 9.364L8.00005 6.828V20H6.00005V6.828L3.46605 9.364L2.05005 7.95L7.00005 3L11.95 7.95ZM21.9501 16.05L17 21L12.05 16.05L13.464 14.636L16.001 17.172L16 4H18V17.172L20.536 14.636L21.9501 16.05Z",
    fill: "#15318D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgE9);
export default __webpack_public_path__ + "static/media/e9.46d4f289879d6f4bd4d90a36110d6929.svg";
export { ForwardRef as ReactComponent };